var _style, _defs, _path, _path2, _path3, _path4, _path5, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfectiousDisease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000041995386305010435460000014899840562234633405_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145038546848112602360000003049465299199328423_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145038546848112602360000003049465299199328423_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  }))))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 51.7,
    cy: 50.6,
    r: 34.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 24.9,
    y1: 26.6,
    x2: 19.4,
    y2: 21.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 17.3,
    y1: 21.5,
    x2: 19.9,
    y2: 19
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 38.6,
    y1: 17.4,
    x2: 35.5,
    y2: 10.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 33.5,
    y1: 9.7,
    x2: 36.9,
    y2: 8.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 55.4,
    y1: 15.7,
    x2: 55.5,
    y2: 7.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 53.8,
    y1: 6.7,
    x2: 57.4,
    y2: 6.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 71.4,
    y1: 20.4,
    x2: 75.7,
    y2: 13.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 75,
    y1: 12,
    x2: 77.9,
    y2: 14
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 23.7,
    y1: 74.3,
    x2: 18.2,
    y2: 79.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16.1,
    y1: 79.5,
    x2: 18.7,
    y2: 81.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 38.6,
    y1: 84.7,
    x2: 35.5,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 33.5,
    y1: 92.3,
    x2: 36.9,
    y2: 93.6
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 55.4,
    y1: 86.3,
    x2: 55.5,
    y2: 94.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 53.8,
    y1: 95.4,
    x2: 57.4,
    y2: 95.2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 71.4,
    y1: 81.6,
    x2: 75.7,
    y2: 88.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 75,
    y1: 90,
    x2: 77.9,
    y2: 88
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 15.9,
    y1: 59.6,
    x2: 7.9,
    y2: 62.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 7.2,
    y1: 64.3,
    x2: 6.1,
    y2: 60.6
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 15.9,
    y1: 40.5,
    x2: 7.6,
    y2: 39.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 6.1,
    y1: 41.4,
    x2: 6.6,
    y2: 37.6
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 83.8,
    y1: 69.4,
    x2: 90.3,
    y2: 73.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 92.2,
    y1: 73,
    x2: 90.2,
    y2: 75.9
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 88.7,
    y1: 53.4,
    x2: 97,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 98.1,
    y1: 56.5,
    x2: 98.5,
    y2: 52.6
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 85.1,
    y1: 34.8,
    x2: 93.1,
    y2: 32.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 94.8,
    y1: 33.8,
    x2: 93.7,
    y2: 30.1
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1,
    cy: 49.8,
    r: 3.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 34.8,
    r: 3.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.4,
    cy: 51,
    r: 3.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfectiousDisease);
export default __webpack_public_path__ + "static/media/Infectious-disease.10c2026bd9e7890ba645f0768deb42ce.svg";
export { ForwardRef as ReactComponent };